// extracted by mini-css-extract-plugin
export default {"Observations":"Observations_Observations__nWNXg"};